export enum types {
  DIVISION_GET_ALL = 'division/getAll',
  DIVISION_CREATE = 'division/create',
  DIVISION_GET_NAME = 'division/getName',
  DIVISION_GET = 'division/get',
  DIVISION_UPDATE = 'division/update',
  DIVISION_REMOVE = 'division/remove',
  DIVISION_CHANGE_PAGE = 'division/changePage',
}
